export class ScheduleAppointmentWidgetSettings {
  public appointmentUrl: string;

  public remindInDays: number;
}
